import { animateScroll } from 'react-scroll'

export function scrollToElement(targetElement = '.form-control-error') {
  setTimeout(() => {
    const elementArrays = document.querySelectorAll(targetElement)
    let elementFirstOccurrence

    if (elementArrays.length > 0) {
      elementFirstOccurrence = elementArrays[0].getBoundingClientRect().top
      animateScroll.scrollTo(elementFirstOccurrence, {
        duration: 400
      })
    }
  }, 0)
}
